import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "apis/axiosConfig";

const AddSubcategory = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axiosInstance.get("/categories");
        const nextCategories = Array.isArray(res.data) ? res.data : [];
        setCategories(nextCategories);
        if (nextCategories[0]?.id) {
          setCategoryId(String(nextCategories[0].id));
        }
      } catch (error) {
        console.error("Failed to load category options:", error);
        setCategories([]);
      }
    };

    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (!categoryId || !trimmedName) return;

    setLoading(true);
    try {
      await axiosInstance.post("/subcategories", {
        category_id: Number(categoryId),
        name: trimmedName,
        status: "Active",
      });
      navigate("/subcategories");
    } catch (error) {
      console.error("Failed to add subcategory:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Subcategory</h4>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row mx-4">
          <div className="col-sm-12 mt-4">
            <label htmlFor="parentCategory" className="admin-label">
              Parent Category
            </label>
            <select
              id="parentCategory"
              className="form-control"
              value={categoryId}
              onChange={(e) => setCategoryId(e.target.value)}
            >
              <option value="">Select category</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-sm-12 mt-4">
            <label htmlFor="subcategoryName" className="admin-label">
              Subcategory Name
            </label>
            <input
              id="subcategoryName"
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-4 text-right mx-4">
          <button className="btn btn-lg addbtn" disabled={loading}>
            Add Subcategory
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSubcategory;
